<template>
  <content-wrapper>
    <Content class="mt-3">
      <b-card header-bg-variant="dark">
        <template #header>
          <b-row class="align-items-center justify-content-between">
            <b-col>
              <h6 class="mb-0">Member</h6>
            </b-col>
            <b-col md="1" v-if="can('superadmin')">
              <b-button variant="outline-light" @click="toUpdate=false;clearForm();viewOnly=false;$bvModal.show('view')">
                <b-icon icon="plus-circle-fill"></b-icon>
                Add
              </b-button>
            </b-col>
          </b-row>
        </template>

        <!-- Table Search -->
        <div class="form-group row">
          <label class="col-sm-2 col-form-label">Search</label>
          <div class="col-sm-4 mb-3">
            <select name="type" class="form-control" v-model="searchForm.type" >
              <option value="Name">Name</option>
              <option value="NIB">NIB</option>
              <option value="NPWP">NPWP</option>
            </select>
          </div>
          <div class="col-sm-6 input-group mb-3">
            <input type="text" class="form-control" placeholder="Keywords" v-model="searchForm.keywords" v-on:keyup.enter="$refs.table.refresh()">
            <span class="input-group-append">
              <button type="button" class="btn btn-info btn-flat" @click="$refs.table.refresh()">
                <i class="fa fa-search"></i> Search
              </button>
            </span>
          </div>
        </div>

        <!--    TABLE SEARCH    -->
        <div class="form-group row">
          <label class="col-sm-2 col-form-label">Filter</label>

          <div class="col-sm-6 mb-3">
            <b-row>
              <b-col sm="12" md="4" class="mb-3">
                <select name="type" class="form-control" v-model="searchForm.dateType">
                  <option value="expiry">Expiry</option>
                  <option value="renewal">Renewal</option>
                </select>
              </b-col>
              <b-col>
                <b-form-datepicker
                    id="startDate"
                    v-model="searchForm.startDate"
                    :max="searchForm.endDate"
                    locale="en-US"
                    label-no-date-selected="Start Date"
                    :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                ></b-form-datepicker>
              </b-col>
              <b-col>
                <b-form-datepicker
                    id="endDate"
                    v-model="searchForm.endDate"
                    locale="en-US"
                    :min="searchForm.startDate"
                    label-no-date-selected="End Date"
                    :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                ></b-form-datepicker>
              </b-col>
            </b-row>
          </div>
          <b-col sm="4" class="mb-3">
            <b-row>
              <b-col>
                <b-form-radio-group
                    buttons
                    button-variant="outline-primary"
                    :options="options.status"
                    name="radios-btn-direction"
                    v-model="searchForm.status"
                    @change="pagination.current=1;$refs.table.refresh()"
                >
                </b-form-radio-group>
              </b-col>
            </b-row>
          </b-col>
          <b-col sm="2" class="mb-3" v-if="false">
            <button type="button" class="btn btn-info btn-block" @click="pagination.current=1;$refs.table.refresh()">
              <i class="fa fa-search"></i> Reload
            </button>
          </b-col>
        </div>

        <div class="table-responsive">
          <!-- Table  -->
          <b-table :per-page="pagination.per_page"
                  :current-page="pagination.current"
                  ref="table"
                  :items="loadPage"
                  :fields="columns"
                  :busy.sync="isLoading"
                  striped
                  borderless
                  outlined
                  hover
                  show-empty
                  empty-text="No records found..."
                  stacked="sm"
                  class="mb-3"
          >
            <template #table-busy>
              <div class="text-center text-primary my-2">
                <b-spinner label="Loading..." type="grow"></b-spinner>
              </div>
            </template>
            <!-- full detail on click -->
            <template #row-details="row">
              <b-card>
                <b-row class="mb-2">
                  <b-col
                      md="6"
                      class="mb-1"
                  >
                    <dl>
                      <dt>Company Name</dt>
                      <dd>{{ row.item.company_name }}</dd>
                      <dt>NIB</dt>
                      <dd>{{ row.item.NIB }}</dd>
                      <dt>NPWP</dt>
                      <dd>{{ row.item.NPWP }}</dd>
                    </dl>
                  </b-col>
                  <b-col
                      md="6"
                      class="mb-1"
                  >
                    <dl>
                      <dt>Expiry</dt>
                      <dd>{{ typeof row.item.expiry === 'string' ?  row.item.expiry.replace(/\+.*/, '') : '-'  }}</dd>
                      <dt>Renewal</dt>
                      <dd>{{ typeof row.item.renewal === 'string' ?  row.item.renewal.replace(/\+.*/, '') : '-'  }}</dd>
                      <dt>Status</dt>
                      <dd>
                        <b-badge :variant="status[0][row.item.status]">
                          {{ status[1][row.item.status] }}
                        </b-badge>
                      </dd>
                    </dl>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col>
                    <b-button-group size="sm">
                      <b-button variant="primary" target="_blank" :disabled="!row.item.nib_img" :href="row.item.nib_img">NIB</b-button>
                      <b-button variant="primary" target="_blank" :disabled="!row.item.npwp_img" :href="row.item.npwp_img">NPWP</b-button>
                    </b-button-group>
                  </b-col>
                  <b-col>
                    <b-button
                        size="sm"
                        variant="outline-secondary"
                        @click="row.toggleDetails"
                    >
                      Hide Details
                    </b-button>
                  </b-col>
                </b-row>
              </b-card>
            </template>
            <template #cell(status)="data">
              <b-badge :variant="status[0][data.value]">
                {{ status[1][data.value] }}
              </b-badge>
            </template>
            <template #cell(actions)="data">
                <b-button squared variant="primary btn-sm" @click="data.toggleDetails">Details</b-button>
                <b-button squared variant="warning btn-sm" v-if="can('superadmin')" @click="editMember(data.item)">Edit</b-button>
                <b-button squared variant="info btn-sm" v-if="can('superadmin')" @click="renewalMember(data.item)">Renewal</b-button>
                <b-button squared variant="danger btn-sm" v-if="can('superadmin')" @click="deleteConfirmation(data.item)">Delete</b-button>
                <b-button squared
                    :variant="data.item.status === 1 ? 'secondary btn-sm' : 'info btn-sm' "
                    @click="setStatus(data.item)"
                >{{ data.item.status === 1 ? 'Disable Me' : 'Enable Me'}}</b-button>
            </template>
          </b-table>
        </div>

        <div class="form-group row justify-content-end">
          <label class="col-sm-1 col-form-label">Per Page</label>
          <div class="col-sm-1 mb-3">
            <b-form-select
                :value="pagination.per_page"
                :options="options.pagination"
                @change="(v) => {pagination.per_page = v; pagination.current = 1}"
            ></b-form-select>
          </div>
          <div class="pr-2">
            <simple-pagination
                v-model="pagination.current"
                :disable-prev="pagination.current === 1"
                :disable-next="pagination.at_last_page"
            />
          </div>
        </div>
      </b-card>
    </Content>
    <!-- Modals  -->
    <b-modal
        centered
        id="view"
        no-close-on-backdrop
        no-close-on-esc
        hide-header-close
        title="Member Detail">
      <b-form-group
          id="input-group-1"
          label="Company"
          label-for="companyName"
      >
        <b-form-input
            id="companyName"
            v-model="$v.member.company_name.$model"
            type="text"
            :readonly="viewOnly"
            :state="validateState('company_name')"
        ></b-form-input>
        <b-form-invalid-feedback>
          This is a required field and must be at least 5 characters.
        </b-form-invalid-feedback>
      </b-form-group>
      <b-row>
        <b-col>
          <b-form-group
              id="input-group-1"
              label="NIB"
              label-for="NIB"
          >
            <b-form-input
                id="NIB"
                v-model="$v.member.NIB.$model"
                type="text"
                :readonly="viewOnly"
                :state="validateState('NIB')"
            ></b-form-input>
            <b-form-invalid-feedback>
              This is a required field and must be at least 5 characters.
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group
              id="input-group-1"
              label="NPWP"
              label-for="NPWP"
          >
            <b-form-input
                id="NPWP"
                v-model="$v.member.NPWP.$model"
                type="text"
                :readonly="viewOnly"
                :state="validateState('NPWP')"
            ></b-form-input>
            <b-form-invalid-feedback>
              This is a required field and must be valid NPWP.
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>
      </b-row>
      <!--   Renewal & Expiry Date   -->
      <b-row>
        <b-col>
          <b-form-group
              label="Expiry"
              label-for="expiry"
          >
            <b-form-datepicker
                id="expiry"
                v-model="$v.member.expiry.$model"
                locale="en-US"
                :state="validateState('expiry')"
                :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
            ></b-form-datepicker>
            <b-form-invalid-feedback>
              This is a required field.
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group
              label="Renewal"
              label-for="renewal"
          >
            <b-form-datepicker
                id="renewal"
                :min="member.expiry"
                v-model="$v.member.renewal.$model"
                locale="en-US"
                :state="validateState('renewal')"
                :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
            ></b-form-datepicker>
            <b-form-invalid-feedback>
              This is a required field.
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>
      </b-row>
      <!--   NIB UPLOAD   -->
      <b-form-group
          label="NIB"
          label-for="NIB_img"
      >
        <b-form-file
            id="NIB_img"
            v-model="file.nib"
            accept="image/jpeg, image/png"
            :state="file.nib ===null ? null : Boolean(file.nib)"
            placeholder="Drop NIB here..."
            drop-placeholder="Drop NIB here..."
        ></b-form-file>
      </b-form-group>
      <!--   NPWP UPLOAD   -->
      <b-form-group
          label="NPWP"
          label-for="NPWP_img"
      >
        <b-form-file
            id="NPWP_img"
            v-model="file.npwp"
            accept="image/jpeg, image/png"
            :state="file.npwp ===null ? null : Boolean(file.npwp)"
            placeholder="Drop NPWP here..."
            drop-placeholder="Drop NPWP here..."
        ></b-form-file>
      </b-form-group>
      <!--   PREVIEW   -->
      <b-row v-if="toUpdate">
        <b-col>
          <label class="col-sm-2 col-form-label">Preview</label>
          <b-button-group size="sm">
            <b-button variant="primary" target="_blank" :disabled="!member.nib_img" :href="member.nib_img">NIB</b-button>
            <b-button variant="primary" target="_blank" :disabled="!member.npwp_img" :href="member.npwp_img">NPWP</b-button>
          </b-button-group>
        </b-col>
      </b-row>
      <template #modal-footer="{ cancel }">
        <b-button variant="primary" :disabled="isSubmitting" @click="submitMember()">
          Submit
          <b-spinner v-if="isSubmitting" small></b-spinner>
        </b-button>
        <b-button variant="secondary" @click="clearForm();cancel()">
          Cancel
        </b-button>
      </template>
    </b-modal>
    <b-modal header-class="bg-danger text-white" id="delete">
      <template #modal-title>
        <b-icon icon="exclamation-triangle-fill"></b-icon> Delete Confirmation
      </template>
      <h1 class="text-center font-weight-bolder">WARNING!</h1>
      <h4 class="text-center">This destructive action is not recoverable! </h4>
      <h4 class="text-center">Are you sure to delete this record?</h4>
      <template #modal-footer="{ ok, cancel, hide }">
        <b-button size="sm" variant="outline-danger" @click="deleteMember(member)">
          Yes, Delete it!
        </b-button>
        <b-button size="sm" variant="secondary" @click="hide('forget')">
          Forget it
        </b-button>
      </template>
    </b-modal>
    <b-modal
        id="renewal"
        header-bg-variant="info"
        no-close-on-backdrop
        no-close-on-esc
        hide-header-close
        title="Renewal Form"
    >
      <b-row>
        <b-col>
          <b-form-group
              label="Expiry"
              label-for="memberExpiry"
          >
            <b-form-datepicker
                id="memberExpiry"
                locale="en-US"
                v-model="renewal.expire"
                :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
            ></b-form-datepicker>
            <b-form-invalid-feedback>
              This is a required field.
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group
              label="Renewal"
              label-for="memberRenewal"
          >
            <b-form-datepicker
                id="memberRenewal"
                locale="en-US"
                :min="renewal.expire"
                v-model="renewal.renewal"
                :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
            ></b-form-datepicker>
            <b-form-invalid-feedback>
              This is a required field.
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>
      </b-row>
      <template #modal-footer="{ cancel }">
        <b-button variant="primary" :disabled="isRenewing" @click="renewMember()">
          Submit
          <b-spinner v-if="isRenewing" small></b-spinner>
        </b-button>
        <b-button variant="secondary" @click="clearForm();cancel()">
          Forget it
        </b-button>
      </template>
    </b-modal>
  </content-wrapper>
</template>

<script>
import ContentWrapper from "@/components/Layouts/ContentWrapper";
import Content from "@/components/Layouts/Content";
// import { isValidNPWP } from 'nusantara-valid';
import {
  listMember,
  // findMemberBy, /*getMemberByID*/
  addMember,
  updateMember,
  deleteMember,
  setMemberStatus, renewMember
} from '@/services/members';
import { upload } from "../services/utils";
import  {
  BBadge, BFormDatepicker, BFormFile,
  BIcon, BIconExclamationTriangleFill,
  BIconPlusCircleFill, BSpinner,
} from 'bootstrap-vue'
import {validationMixin} from "vuelidate";
import { required, minLength, numeric } from "vuelidate/lib/validators";
import SimplePagination from "@/components/SimplePagination";
import {hasOwnProperty} from "@/helpers/Utils";
export default {
  name: "Members",
  components: {
    Content, ContentWrapper,
    BIcon,
    BBadge, BFormDatepicker, BFormFile, BSpinner,
    // eslint-disable-next-line vue/no-unused-components
    BIconPlusCircleFill, BIconExclamationTriangleFill,
    SimplePagination,
  },
  mixins: [validationMixin],
  validations:{
    member: {
      company_name: {
        required,
        minLength: minLength(5),
      },
      NPWP: {
        required,
        // isValidNPWP,
      },
      NIB: {
        required,
        numeric,
        minLength: minLength(5),
      },
      expiry: {
        required,
      },
      renewal: {
        required,
      },
    },
    renewal: {
      expire: {
        required,
      },
      renewal: {
        required,
      },
    }
  },
  data: () => ({
    file: {
      nib: null,
      npwp: null,
    },
    isLoading: false,
    isSubmitting: false,
    columns: [
      {
        key: 'id',
        label: 'ID',
      },
        {
        key: 'company_name',
        label: 'Name',
      },
      {
        key: 'NIB',
        label: 'NIB',
      },
      {
        key: 'expiry',
        label: 'Expiry',
        formatter: x => typeof x === 'string' ?  x.replace(/\+.*/, '') : '-',
      },
      {
        key: 'renewal',
        label: 'Renewal',
        formatter: x => typeof x === 'string' ?  x.replace(/\+.*/, '') : '-',
      },
      {
        key: 'status',
        label: 'Status',
      },
      {
        key: 'actions',
        label: 'Actions',
      }
    ],
    pagination: {
      current: 1,
      last_page: 15,
      total_items:0,
      per_page: 10,
      at_last_page: false,
    },
    member: {
      company_name: '',
      NPWP: '',
      NIB: '',
      expiry: null,
      renewal: null,
      npwp_img: null,
      nib_img: null,
    },
    viewOnly: true,
    status: [
      {
        0: 'danger', 1: 'primary',
      },
      {
        0: 'Inactive', 1: 'Active',
      }
    ],
    toUpdate: false,
    searchForm: {
      keywords: '',
      type: 'Name',
      dateType: 'expiry',
      startDate:null,
      endDate:null,
      status:1,
    },
    options: {
      status: [
        {text: 'INACTIVE', value: 0},
        {text: 'ACTIVE', value: 1},
      ],
      pagination: [
        10,
        20,
        30,
        40,
        50,
        80,
        100,
      ],
    },
    renewal: {
      id: 0,
      expiry: '',
      renewal: '',
    },
    isRenewing: false,
  }),
  methods: {
    async loadPage(ctx) {
      this.isLoading = true;
      this.pagination.at_last_page = false;
      this.pagination.total_item = 0;
      try {
        const {data: {data: {rows}}} = await listMember(this.searchParams(ctx));
        const members = Array.isArray(rows.member) ? rows.member : [rows.member];
        this.pagination.total_items = members.length
        this.pagination.at_last_page = this.pagination.total_items < this.pagination.per_page;
        return members;
      } catch (e) {
        this.isLoading = false;
        this.pagination.at_last_page = true;
        return [];
      }
    },
    async getMemberById(member) {
      this.viewOnly = true;
      // const {data: {data: {rows}}} = await getMemberByID(id);
      this.member = member
      // this.member = rows.member;
      this.$bvModal.show('view')
    },
    editMember(member) {
      this.member = member;
      this.member.expiry = typeof member.expiry === 'string' ?  member.expiry.replace(/\+.*/, '') : null;
      this.member.renewal = typeof member.renewal === 'string' ?  member.renewal.replace(/\+.*/, '') : null;
      this.member.npwp_img = typeof member.npwp_img === 'string' ?  member.npwp_img.replace(/\+.*/, '') : null;
      this.member.nib_img = typeof member.nib_img === 'string' ?  member.nib_img.replace(/\+.*/, '') : null;
      this.viewOnly = false;
      this.toUpdate = true;
      this.$bvModal.show('view')
    },
    deleteConfirmation(member) {
      this.member = member;
      this.$bvModal.show('delete')
    },
    async deleteMember(member) {
      this.$bvModal.hide('delete')
      await deleteMember(member.id)
      this.$bvToast.toast(`Member [${member.company_name}] delete successfully`, {
        title: 'Deleted!',
        autoHideDelay: 1500,
        appendToast: false,
        variant: 'success',
      })
      this.pagination.current=1;
      this.$refs.table.refresh()
    },
    async submitMember() {
      if (!this.can('superadmin')) {
        this.$bvToast.toast(`Unauthorized Access!`, {
          title: 'Error!',
          autoHideDelay: 1500,
          variant: 'danger',
        })
        return
      }
      this.$v.member.$touch();
      if (this.$v.member.$anyError) {
        this.$bvToast.toast(`Missing required information!`, {
          title: 'Error!',
          autoHideDelay: 1500,
          variant: 'danger',
        })
        return;
      }
      if (!this.toUpdate && (!this.file.nib || !this.file.npwp)) {
        this.$bvToast.toast(`Please attached both NPWP & NIB`, {
          title: 'Error!',
          autoHideDelay: 1500,
          variant: 'danger',
        })
        return;
      }
      try {
        this.isSubmitting = true;
        if (this.file.nib) {
          if (this.file.nib.size > 1_000_000) {
            this.$bvToast.toast(`NIB image too large! Max size: 1MB only`, {
              title: 'Error!',
              autoHideDelay: 1500,
              variant: 'danger',
            })
            return;
          }
          this.member.nib_img = await this.uploadImage(this.file.nib)
        }
        if (this.file.npwp) {
          if (this.file.npwp.size > 1_000_000) {
            this.$bvToast.toast(`NPWP image too large! Max size: 1MB only`, {
              title: 'Error!',
              autoHideDelay: 1500,
              variant: 'danger',
            })
            return;
          }
          this.member.npwp_img = await this.uploadImage(this.file.npwp)
        }
        if (typeof this.member.nib_img !== 'string') {
          this.member.nib_img = null;
        }
        if (typeof this.member.npwp_img !== 'string') {
          this.member.npwp_img = null;
        }
        if (typeof this.member.renewal !== 'string') {
          this.member.renewal = null;
        }
        if (this.toUpdate) {
          await updateMember(this.member);
        } else {
          await addMember(this.member);
        }
        this.$bvToast.toast(`Member saved Success!`, {
          title: 'Congratulation!',
          autoHideDelay: 1500,
          variant: 'success',
        })
        this.clearForm();
        this.isSubmitting=false;
        this.$bvModal.hide('view')
        this.pagination.current=1;
        this.$refs.table.refresh()
      } catch (e) {
        // do something here
        if (!hasOwnProperty(e, 'response')) {
          this.$bvToast.toast(`${e.message}`, {
            title: 'Error!',
            autoHideDelay: 1500,
            variant: 'danger',
          })
          return;
        }
      }
      this.isSubmitting=false;
    },
    clearForm() {
      this.member = {
        company_name: '',
        NPWP: '',
        NIB: '',
        expiry: null,
        npwp_img: null,
        nib_img: null,
      }
      this.file.npwp = null
      this.file.nib = null
      this.renewal = {
        id: 0,
        expiry: '',
        renewal: '',
      }
      this.$nextTick(() => {
        this.$v.$reset();
      });
    },
    async uploadImage(file) {
      const {data: {data: {path}}} = await upload({ file });
      return path;
    },
    async setStatus(member) {
      let status = Number(!member.status);
      try {
        await setMemberStatus(member.id, status);
        this.$bvToast.toast(`${member.company_name} Status Updated!`, {
          title: 'Congratulation!',
          autoHideDelay: 1500,
          variant: 'success',
        })
        this.pagination.current=1;
        this.$refs.table.refresh()
      } catch (e) {
        if (!hasOwnProperty(e, 'response')) {
          this.$bvToast.toast(`${e.message}`, {
            title: 'Error!',
            autoHideDelay: 1500,
            variant: 'danger',
          })
          return;
        }
      }
    },
    validateState(name) {
      const { $dirty, $error } = this.$v.member[name];
      return $dirty ? !$error : null;
    },
    renewalMember(member) {
      this.renewal.id = member.id
      this.renewal.expire = typeof member.expiry === 'string' ?  member.expiry.replace(/\+.*/, '') : null;
      this.renewal.renewal = typeof member.renewal === 'string' ?  member.renewal.replace(/\+.*/, '') : null;
      this.$bvModal.show('renewal')
    },
    searchParams(ctx) {
      const searchData = {
        status: this.searchForm.status,
        [`${this.searchForm.type === 'Name' ? 'name' : this.searchForm.type}`]: `%${this.searchForm.keywords}%`,
        per_page: this.pagination.per_page,
        current_page: this.pagination.current,
        date_type: this.searchForm.dateType,
      };
      if (ctx.sortBy !== '') {
        const direction = ctx.sortDesc ? 'desc': 'asc';
        searchData['order_by'] = `${ctx.sortBy},${direction}`;
      }
      if (this.searchForm.startDate) {
        searchData['start_date'] = this.searchForm.startDate;
      }
      if (this.searchForm.endDate) {
        searchData['end_date'] = this.searchForm.endDate;
      }
      return searchData;
    },
    async renewMember() {
      this.$v.renewal.$touch();
      if (this.$v.renewal.$anyError) {
        this.$bvToast.toast(`Missing required information!`, {
          title: 'Error!',
          autoHideDelay: 1500,
          variant: 'danger',
        })
        return;
      }
      try {
        this.isRenewing = true;
        await renewMember(this.renewal);
        this.$bvToast.toast(`Success renew member!`, {
          title: 'Congratulation!',
          autoHideDelay: 1500,
          variant: 'success',
        })
        this.isRenewing = false;
        this.$bvModal.hide('renewal')
        this.pagination.current=1;
        this.$refs.table.refresh()
      } catch (e) {
        this.isRenewing = false;
        if (!hasOwnProperty(e, 'response')) {
          this.$bvToast.toast(`${e.message}`, {
            title: 'Error!',
            autoHideDelay: 1500,
            variant: 'danger',
          })
          return;
        }
      }
    }
  },
  created() {
/*
    if (window.performance) {
      console.info("window.performance is supported");
      // do something based on the navigation type...
      switch(performance.navigation.type) {
        case 0:
          console.info("TYPE_NAVIGATE");
          break;
        case 1:
          console.info("TYPE_RELOAD");
          break;
        case 2:
          console.info("TYPE_BACK_FORWARD");
          break;
        case 255:
          console.info("255");
          break;
      }
      this.handler =  function (e) {
            console.log('BEFORE RELOAD')
            // Cancel the event
            e.preventDefault();
            // Chrome requires returnValue to be set
            e.returnValue = '';
          };
//      window.addEventListener('onbeforereload',this.handler);
      window.addEventListener('beforeunload',this.handler);
    }
*/    
  }
}
</script>

<style scoped>

</style>
